import { useEffect, useState } from "react";
import styles from "./Checkout.module.css";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import load from "../../../Images/loading.gif";

function Checkout() {
    const { id } = useParams();
    const [user, setUser] = useState(null);
    const [plano, setPlano] = useState(null);
    const [nomeServico, setNomeServico] = useState("");
    const [cupom, setCupom] = useState("");
    const [desconto, setDesconto] = useState(0);
    const [precoFinal, setPrecoFinal] = useState(0);
    const [validandoCupom, setValidandoCupom] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const init = async () => {
            const getUser = async () => {
                try {
                    const res = await axios.get("https://eclipsebots.com/api/profile", { withCredentials: true });
                    setUser(res.data);
                } catch {
                    setUser(null);
                }
            };

            const fetchPlan = async () => {
                try {
                    const response = await fetch(`https://eclipsebots.com/api/planos/${id}`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        credentials: "include"
                    });

                    if (!response.ok) {
                        throw new Error("Failed to fetch plan");
                    }

                    const data = await response.json();
                    setPlano(data[0]);
                    setPrecoFinal(data[0].price);
                } catch (error) {
                    console.error("Erro ao buscar plano:", error);
                    setPlano(null);
                }
            };

            await getUser();
            await fetchPlan();
            setLoading(false);
        };

        init();
    }, [id]);



    const aplicarCupom = async () => {
        setValidandoCupom(true);
        const res = await fetch("https://eclipsebots.com/api/coupons/validate", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                cupom,
                userId: user.id,
                purchaseValue: plano.price
            }),
        });
        const data = await res.json();

        if (data.valido) {
            const descontoValor = plano.price - data.valorFinal;
            setDesconto(descontoValor);
            setPrecoFinal(data.valorFinal);
        } else {
            alert("Cupom inválido");
        }
        setValidandoCupom(false);
    };

    const confirmarPagamento = async () => {
        if (!nomeServico) return alert("Diz aí o nome do serviço!");

        const res = await fetch("https://eclipsebots.com/api/faturas/create", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
                userId: user.id,
                serviceName: nomeServico,
                planId: plano.planId,
                amount: precoFinal || plano.price,
            }),
        });

        const data = await res.json();
        if (data.payment_url) {
            window.location.href = data.payment_url;
        } else {
            alert("Erro ao gerar fatura.");
        }
    };


    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    if (!user) {
        return (<div className={styles.content}>
            <div style={{ padding: "10rem 0" }} className={`${styles.size} ${styles.checkout}`}>
                Tens de ter sessão iniciada para executar esta ação.  <Link to={"/login"}>Iniciar Sessão</Link>
            </div>
        </div>)
    }

    if (user.role !== "Administrador") {
        return (<div className={styles.content}>
            <div style={{ padding: "10rem 0" }} className={`${styles.size} ${styles.checkout}`}>
                Esta página é apenas acessivel ao desenvolvedor, volte mais tarde!
            </div>
        </div>)
    }

    const precoPlano = plano.price;

    return (
        <div className={styles.content}>
            <div className={`${styles.size} ${styles.checkout}`}>
                <div className={styles.checkContent}>
                    <h1>Checkout do Plano</h1>
                    <div className={styles.card}>
                        <label>Nome do Serviço</label>
                        <input
                            type="text"
                            value={nomeServico}
                            onChange={(e) => setNomeServico(e.target.value)}
                            placeholder="Ex: EclipseBOT Premium"
                            required
                        />

                        <label className={styles.cupomLabel}>Cupom de Desconto (opcional)</label>
                        <div className={styles.cupomRow}>
                            <input
                                type="text"
                                value={cupom}
                                onChange={(e) => setCupom(e.target.value)}
                                placeholder="Digite o cupom"
                            />
                            <button onClick={aplicarCupom} disabled={validandoCupom}>
                                Aplicar
                            </button>
                        </div>

                        <div className={styles.resumo}>
                            <p>Valor original: <strong>R${precoPlano.toFixed(2)}</strong></p>
                            <p>Desconto: - <strong>R${desconto.toFixed(2)}</strong></p>
                            <p className={styles.total}>
                                Total a pagar: <strong>R${precoFinal.toFixed(2)}</strong>
                            </p>
                        </div>

                        <button className={styles.confirmar} onClick={confirmarPagamento}>
                            Confirmar e Pagar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Checkout;
